// extracted by mini-css-extract-plugin
export default {"title":"Nba-z","warning":"Oba-z","sizeOptionsLegendText":"Pba-z"};